import { render, staticRenderFns } from "./personalReminderData.vue?vue&type=template&id=ecd4f678&scoped=true&"
import script from "./personalReminderData.vue?vue&type=script&lang=ts&"
export * from "./personalReminderData.vue?vue&type=script&lang=ts&"
import style0 from "./personalReminderData.vue?vue&type=style&index=0&id=ecd4f678&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd4f678",
  null
  
)

export default component.exports